import {
    REQUEST_VEHICLES_AVAILABLE, REQUEST_VEHICLES_AVAILABLE_FAILURE,
    REQUEST_VEHICLES_AVAILABLE_SUCCESS
} from "../../../constant/transaction/ShipmentConstant";


const initialState = {
    vehiclesAvailable: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const vehiclesAvailableReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_VEHICLES_AVAILABLE:
            return {
                ...state,
                vehiclesAvailable: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_VEHICLES_AVAILABLE_SUCCESS:
            return {
                ...state,
                vehiclesAvailable: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_VEHICLES_AVAILABLE_FAILURE:
            return {
                ...state,
                vehiclesAvailable: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
